var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMindsetBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 301.63 210.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#48b2d2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.6,210l-.6-111.3-54,90.6h-26.4L54.9,101.7v108.3H0V0H55L122.7,111.49,188.96,0h54.65l.6,210h-54.6Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 282.66,
    cy: 134.44,
    r: 18.97
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 282.66,
    cy: 191.36,
    r: 18.97
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 282.66,
    cy: 77.52,
    r: 18.97
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 282.66,
    cy: 20.61,
    r: 18.97
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMindsetBlue);
export default __webpack_public_path__ + "static/media/MindsetBlue.1574137b3194ffb6602d6dcd1f0270ca.svg";
export { ForwardRef as ReactComponent };